import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Container, Header } from "../formComponents.styles";
import {
  BlueButton,
  OutlineButton,
  SaveButtonContainer,
  StyledForm,
} from "../../Admin.styles";
import MonthDot from "../../../../assets/Admin/MonthDot.png";
import Eye from "../../../../assets/Admin/Eye";
import TrashCan from "../../../../assets/Admin/TrashCan";
import {
  ButtonWrapper,
  DotImg,
  FilledCheckInContainer,
  MonthWrapper,
  OverlayContainer,
  PreviewContainer,
  SVGButton,
  Year,
  YearsContainer,
  YearWrapper,
} from "./checkIn.styles";
import { Api } from "../../../../services/api";
import {
  CheckInName,
  CheckInProps,
  CheckInRoutes,
  CheckIns,
  CheckinType,
  CheckInTypes,
  MonthCheckIns,
  MonthNames,
  today,
} from "../../../../services/api/types/Members";
import { FileUpload, PreviewFile } from "@milestone/component-library";
import { Formik } from "formik";
import * as Yup from "yup";
import { useMemberDetails } from "../../../../services/hooks/MemberDetails";

interface MonthlyCheckin {
  month: number;
  year: number;
  id?: string;
}

export const MonthlySchema = Yup.object({
  monthlyFiles: Yup.mixed(),
});
//TODO delete not working

export const CheckInsHome: React.FC<{}> = () => {
  const currentYear = today.getFullYear();
  const history = useHistory();
  const { memberId } = useParams<{ memberId: string }>();
  const [checkIns, setCheckIns] = useState<CheckIns>();
  const member = useMemberDetails(memberId);
  const [monthlyCheckin, setMonthlyCheckin] = useState<MonthlyCheckin>();
  const [monthlyFiles, setMonthlyFiles] = useState(
    new Map<string, File | Blob>()
  );
  const [monthlyLoaded, setMonthlyLoaded] = useState(false);

  const getCheckins = async () => {
    const res = await Api.members.getCheckIns(memberId);
    setCheckIns(res.data);
  };

  useEffect(() => {
    getCheckins();
  }, [memberId]);

  const getCheckIn = async (checkInId: string) => {
    const res = await Api.members.getCheckIn(memberId, checkInId);
    let download: File | Blob = new File([], res.data.checkinUploadName);
    download = await Api.members.getCheckInFile(memberId, checkInId);
    setMonthlyFiles(new Map([[res.data.checkinUploadName, download]]));
    setMonthlyLoaded(true);
  };

  useEffect(() => {
    if (monthlyCheckin) {
      if (monthlyCheckin.id) {
        getCheckIn(monthlyCheckin.id);
      } else {
        setMonthlyFiles(new Map());
        setMonthlyLoaded(true);
      }
    } else setMonthlyLoaded(false);
  }, [monthlyCheckin]);

  const overlayClickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLDivElement;
    if (target.id === "monthlyCheckin-overlay") {
      setMonthlyCheckin(undefined);
    }
  };

  const submitValues = async (values: {
    monthlyFiles: Map<string, File | Blob>;
  }) => {
    if (monthlyCheckin && values.monthlyFiles.size) {
      try {
        const data = {};
        if (monthlyCheckin.id) {
          await Api.members.updateCheckIn(
            memberId,
            monthlyCheckin.id,
            data,
            new Date(monthlyCheckin.year, monthlyCheckin.month),
            CheckinType.MONTHLY_CHECKIN,
            values.monthlyFiles.values().next().value
          );
        } else {
          await Api.members.createCheckIn(
            memberId,
            data,
            new Date(monthlyCheckin.year, monthlyCheckin.month),
            CheckinType.MONTHLY_CHECKIN,
            values.monthlyFiles.values().next().value
          );
        }
        getCheckins();
        setMonthlyCheckin(undefined);
      } catch (error) {
        console.error("Update CheckIn", error);
      }
    }
  };

  const buildCheckIn =
    (type: CheckInName, year: string, month: string, checkInId?: string) =>
    () => {
      if (type === CheckInTypes.monthly) {
        const monthIndex = MonthNames.findIndex(value => value === month);
        const yearNumber = Number(year);
        setMonthlyCheckin({
          year: yearNumber,
          month: monthIndex,
          id: checkInId,
        });
        return;
      }
      const currentLocation = history.location;
      if (checkInId)
        currentLocation.pathname = `${currentLocation.pathname}/${CheckInRoutes[type]}/${checkInId}`;
      else
        currentLocation.pathname = `${currentLocation.pathname}/${CheckInRoutes[type]}`;
      currentLocation.search = "?" + new URLSearchParams({ year, month });
      history.push(currentLocation);
    };
  const removeCheckIn = (checkInId: string) => async () => {
    await Api.members.deleteCheckIns(memberId, checkInId);
    getCheckins();
  };

  const CheckIn: React.FC<CheckInProps> = ({
    checkInType,
    year,
    month,
    checkInId,
  }) => {
    return (
      <FilledCheckInContainer>
        {checkInType}
        <SVGButton onClick={buildCheckIn(checkInType, year, month, checkInId)}>
          <Eye />
        </SVGButton>
        <SVGButton onClick={removeCheckIn(checkInId)}>
          <TrashCan />
        </SVGButton>
      </FilledCheckInContainer>
    );
  };

  const buildYear = (year: number) => {
    const months = [];
    const hireDate = member?.member.hireDate || new Date();
    for (const [i, month] of MonthNames.entries()) {
      const monthDate = new Date(year, i);
      let checkIn: MonthCheckIns | undefined;
      if (checkIns) checkIn = checkIns[year][month];
      //skip days that are after today or before hire date
      if (monthDate > today || monthDate < hireDate) continue;
      months.push(
        <div key={month + year}>
          <MonthWrapper>
            <DotImg src={MonthDot} />
            {month}
          </MonthWrapper>
          <ButtonWrapper>
            {
              // 90 Day Check in
              checkIn && checkIn.NinetyDayCheckIn !== undefined ? (
                checkIn.NinetyDayCheckIn !== null ? (
                  <CheckIn
                    checkInType={CheckInTypes.ninety}
                    year={year.toString()}
                    month={month}
                    checkInId={checkIn.NinetyDayCheckIn}
                  />
                ) : (
                  <OutlineButton
                    type="button"
                    onClick={buildCheckIn(
                      CheckInTypes.ninety,
                      year.toString(),
                      month
                    )}
                  >
                    Add 90 Day Check-in
                  </OutlineButton>
                )
              ) : null
            }

            {checkIn && checkIn.MonthlyCheckIn ? (
              <CheckIn
                checkInType={CheckInTypes.monthly}
                year={year.toString()}
                month={month}
                checkInId={checkIn.MonthlyCheckIn}
              />
            ) : (
              <OutlineButton
                type="button"
                onClick={buildCheckIn(
                  CheckInTypes.monthly,
                  year.toString(),
                  month
                )}
              >
                Add Monthly Check-in
              </OutlineButton>
            )}
          </ButtonWrapper>
        </div>
      );
    }
    return months.reverse();
  };

  const SetYears = () => {
    //build current year then previous year
    const years = [];
    for (let i = 0; i < 2; i++) {
      const year = currentYear - i;
      const months = buildYear(year);
      let annualCheckIn: string | undefined;
      const hireDate = member?.member.hireDate || new Date();
      const hireMonth = MonthNames[hireDate.getMonth()];
      //find annual checkin
      if (checkIns && checkIns[year]) {
        const checkIn = Object.values(checkIns[year]).find(
          value => value.AnnualCheckIn
        );
        if (checkIn) annualCheckIn = checkIn.AnnualCheckIn;
      }
      if (months.length) {
        years.push(
          <YearWrapper key={year}>
            <Year>{year}</Year>
            {annualCheckIn ? (
              <CheckIn
                checkInType={CheckInTypes.annual}
                year={year.toString()}
                month={hireMonth}
                checkInId={annualCheckIn}
              />
            ) : (
              <OutlineButton
                type="button"
                onClick={buildCheckIn(
                  CheckInTypes.annual,
                  year.toString(),
                  hireMonth
                )}
              >
                Add Annual Check-in
              </OutlineButton>
            )}
            {months}
          </YearWrapper>
        );
      }
    }
    return years;
  };

  const SaveButtons = (
    <SaveButtonContainer>
      <BlueButton type="submit">Save</BlueButton>
      <OutlineButton type="button" onClick={() => setMonthlyCheckin(undefined)}>
        Cancel
      </OutlineButton>
    </SaveButtonContainer>
  );

  const showMonthlyCheckin = () => {
    return (
      <OverlayContainer
        id={"monthlyCheckin-overlay"}
        onClick={overlayClickHandler}
      >
        <Formik
          initialValues={{ monthlyFiles }}
          validationSchema={MonthlySchema}
          onSubmit={submitValues}
        >
          {({ values }) => (
            <StyledForm>
              {monthlyCheckin?.id && values.monthlyFiles.size ? (
                <PreviewFile
                  previewFile={values.monthlyFiles.values().next().value}
                  setPreviewFile={setMonthlyCheckin}
                  name={"checkinViewer"}
                />
              ) : (
                <PreviewContainer>
                  <FileUpload
                    hideAtMax
                    label={"Add Monthly Checkin"}
                    name={"monthlyFiles"}
                    maxNumberOfFiles={1}
                  />
                  {!!values.monthlyFiles.size && SaveButtons}
                </PreviewContainer>
              )}
            </StyledForm>
          )}
        </Formik>
      </OverlayContainer>
    );
  };

  return (
    <Container>
      <Header>View Check-ins</Header>
      {checkIns && <YearsContainer>{SetYears()}</YearsContainer>}
      {monthlyCheckin && monthlyLoaded && showMonthlyCheckin()}
    </Container>
  );
};
